<div class="wrapper" [class.is-impersonation]="isImpersonation">
  <button
    type="button"
    aria-label="Account"
    i18n-aria-label
    class="avatar"
    [class.badge]="highlightApiKeyService.unread$ | async"
    [style.background-color]="bgColor"
    [matTooltip]="tooltip"
    matTooltipPosition="after"
    [matMenuTriggerFor]="menu"
    data-cy="sidenav-userpre-button"
  >
    <span [style.color]="txtColor" class="initials">{{ initials }}</span>
  </button>

  @if (isImpersonation) {
    <button
      (click)="loginService.logoutImpersonate()"
      class="button-with-variable"
      data-cy="sidenav-stop-impersonate-button"
      mat-icon-button
      type="button"
      matTooltip="Stop impersonate"
      i18n-matTooltip
    >
      <mat-icon class="material-icons-outlined">logout</mat-icon>
    </button>
  }
</div>
<mat-menu #menu="matMenu" data-cy="sidenav-menu">
  <ng-template matMenuContent>
    <div class="actions-group">
      <button
        [matMenuTriggerFor]="menuTheme"
        data-cy="sidenav-open-theme-button"
        mat-menu-item
        type="button"
      >
        <mat-icon
          inline="true"
          class="mat-side-nav__footer__content__icon material-icons-outlined"
          color="accent"
          >light_mode</mat-icon
        >
        <span i18n>Theme</span>
      </button>

      <button
        data-cy="sidenav-language-button"
        mat-menu-item
        type="button"
        (click)="openDialogDateLangFormat()"
      >
        <mat-icon
          inline="true"
          class="mat-side-nav__footer__content__icon material-icons-outlined"
          color="accent"
          >language</mat-icon
        >
        <span i18n>Language and date format</span>
      </button>
    </div>
    <div class="actions-group">
      <a
        [routerLink]="['preferences']"
        data-cy="sidenav-open-preferences-button"
        mat-menu-item
        type="button"
      >
        <mat-icon
          inline="true"
          class="mat-side-nav__footer__content__icon material-icons-outlined"
          color="accent"
          >settings</mat-icon
        >
        <span i18n>Preferences</span>
      </a>

      <a [routerLink]="['keys']" data-cy="sidenav-open-apikeys-button" mat-menu-item type="button">
        <mat-icon
          inline="true"
          class="mat-side-nav__footer__content__icon material-icons-outlined"
          color="accent"
          >vpn_key</mat-icon
        >
        <div class="flex-row-horizontal-space-between-vertical-center">
          <span i18n>Api keys</span>
          @if (highlightApiKeyService.unread$ | async; as count) {
            <mat-chip class="highlight-chip warning">{{ count }}</mat-chip>
          }
        </div>
      </a>
    </div>
    <div class="actions-group">
      <button
        (click)="openDialogEULA()"
        data-cy="sidenav-open-eula-button"
        mat-menu-item
        type="button"
      >
        <mat-icon
          inline="true"
          class="mat-side-nav__footer__content__icon material-icons-outlined"
          color="accent"
          >text_snippet</mat-icon
        >
        <span i18n>Read EULA</span>
      </button>
    </div>
    <div class="actions-group">
      @if (!isImpersonation) {
        <button
          (click)="logoutButton()"
          data-cy="sidenav-signout-button"
          mat-menu-item
          type="button"
          class="fill-red"
        >
          <mat-icon
            inline="true"
            class="mat-side-nav__footer__content__icon material-icons-outlined"
            color="accent"
            >logout</mat-icon
          >
          <span i18n>Logout</span>
        </button>
      }
    </div>
  </ng-template>
</mat-menu>

<mat-menu #menuTheme="matMenu" data-cy="sidenav-theme-menu">
  <ng-template matMenuContent>
    <div class="actions-group__theme">
      <mat-radio-group
        color="primary"
        [ngModel]="themeService.theme"
        (ngModelChange)="onSelectTheme($event)"
      >
        <mat-radio-button
          [disableRipple]="true"
          i18n
          [value]="TypeTheme.AUTO"
          [attr.data-cy]="TypeTheme.AUTO"
          >Auto
        </mat-radio-button>
        <mat-radio-button
          [disableRipple]="true"
          i18n
          [value]="TypeTheme.LIGHT"
          [attr.data-cy]="TypeTheme.LIGHT"
          >Light
        </mat-radio-button>
        <mat-radio-button
          [disableRipple]="true"
          i18n
          [value]="TypeTheme.DARK"
          [attr.data-cy]="TypeTheme.DARK"
          >Dark
        </mat-radio-button>
      </mat-radio-group>
    </div>
  </ng-template>
</mat-menu>
